import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  request => {
    const accessToken = localStorage.getItem("access_token");
    if (request.url?.includes("auth/refresh")) request.headers.Authorization = `Bearer ${localStorage.getItem("refresh_token")}`;
    else if (accessToken) request.headers.Authorization = `Bearer ${accessToken}`;

    return request;
  },
  error => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  response => response, // Directly return successful responses.
  async error => {
    const originalRequest = error.config;
    originalRequest.headers = originalRequest.headers || {};

    if (originalRequest.url?.includes("auth/refresh")) return Promise.reject(error);
    if (!error.response || error.response.status != 401 || originalRequest._retry) return Promise.reject(error);

    originalRequest._retry = true; // Mark the request as retried to avoid infinite loops.
    try {
      const response = await axiosInstance.post("auth/refresh", null);
      const { access_token, refresh_token } = response.data;
      const tokenString = `Bearer ${access_token}`;

      localStorage.setItem("access_token", access_token);
      localStorage.setItem("refresh_token", refresh_token);

      axiosInstance.defaults.headers.common["Authorization"] = tokenString;
      originalRequest.headers["Authorization"] = tokenString;
      return axiosInstance(originalRequest); // Retry the original request with the new access token.
    } catch (refreshError) {
      console.error("Token refresh failed:", refreshError);
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      window.location.href = "login.html";
      return Promise.reject(refreshError);
    }
  }
);

export default axiosInstance;